import script from "./CountryAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./CountryAvatar.vue?vue&type=style&index=0&id=8094db94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8094db94"]])

export default __exports__